// Module
var code = `<div id="page-header page-header-compare"></div>
<div id="page-body">
  <div class="page-content page-compare-content"></div>
</div>
`;
// Exports
module.exports = code;